export default function PesquisarFornecedor(){
    return (
        "Pesquisar Fornecedor"
    );
}